export const getNextNumber = (index: number, documentCount: number): number =>
  documentCount + index + 1;
